export const loadBaslandiJob = () => {
  try {
    const serializedState = localStorage.getItem('baslandiFis');
    if (serializedState === null || serializedState.FisNo) {
      return [];
    }
    return [JSON.parse(serializedState)];
  } catch (err) {
    return [];
  }
};
export const loadUrunControlDetail = () => {
  try {
    const serializedState = localStorage.getItem('UrunControlDetail');
    if (serializedState === null || serializedState === undefined) {
      return [];
    }
    return [JSON.parse(serializedState)];
  } catch (err) {
    return [];
  }
};


export const saveUrunControlDetail = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.removeItem('UrunControlDetail');
    localStorage.setItem('UrunControlDetail', serializedState);
  } catch (error) {
    // ignore write errors
  }
};

export const saveBaslandiJob = (state) => {
  try {
    const error = new Error();
    const stack = error.stack.split("\n");
    let callerName = 'Unknown Component';

    // Stack trace'den component ismini çıkarma
    for (let i = 0; i < stack.length; i++) {
      if (stack[i].includes('at')) {
        const match = stack[i].match(/at\s+([A-Za-z0-9_$]+)\s+/);
        if (match && match[1] && !['Object', 'saveBaslandiJob'].includes(match[1])) {
          callerName = match[1];
          break;
        }
      }
    }
    const serializedState = JSON.stringify(state);
    localStorage.removeItem('baslandiFis');
    localStorage.setItem('baslandiFis', serializedState);
    if (callerName !== 'commitHookEffectListMount') {
      const event = new Event('localStorageChange');
      window.dispatchEvent(event);
    }

  } catch (error) {
    // ignore write errors
  }
};


export const removeBaslandiJob = () => {
  localStorage.removeItem('baslandiFis');
};

// Okutulan barkod ile kul model kodu uyuşuyor mu kontrolü
export const checkValidBarkod = () => {
  const job = loadBaslandiJob()[0];
  const barkod = job.BARKOD || '';
  if ([18, 20, 22].indexOf(barkod.length) === -1) { return true; }
  const model_length = barkod.length === 18 ? 6 : 10;
  const txt_kul_model_kodu = barkod.substring(0, model_length);

  if (txt_kul_model_kodu.slice(-2) === 'RV' || txt_kul_model_kodu.slice(-2) === '99') { // Revizyonlu ürünler
    return true;
  }
  return barkod.indexOf(job.KUL_MODEL_KODU) !== -1;
};

// Homewhiz mesajı gösterilmeli mi kontrolü
export const checkHomewhiz = (hizmetKoduKontrol) => {
  const job = loadBaslandiJob()[0];
  if (job === undefined) return false;
  if (!hizmetKoduKontrol) {
    return job.HOMEWHIZ && parseInt(job.MARKA_KODU) !== 58;
  }
  let hizmet514 = false; // 514 hizmeti var mı diye kontrol ediyoruz
  job.WorkOrderDetails.forEach((h) => {
    // TODO: Yeni sistemdeki 514 hizmetine denk gelen kod ile değiştirilmesi gerekiyor
    if (h.DefectId === 235) {
      hizmet514 = true;
    }
  });
  return hizmet514 && job.HOMEWHIZ && parseInt(job.MARKA_KODU) !== 58;
};
